import client from './client';

export interface AuditLog {
  id: number;
  tabla: string;
  accion: 'INSERT' | 'UPDATE' | 'DELETE';
  usuarioId: number | null;
  datosJson: Record<string, any>;
  createdAt: string;
}

export interface AuditLogsResponse {
  data: AuditLog[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface AuditLogsFilters {
  modulo?: string;
  actorId?: number;
  accion?: 'INSERT' | 'UPDATE' | 'DELETE';
  desde?: string;
  hasta?: string;
  page?: number;
  limit?: number;
}

export const auditLogApi = {
  getAll: (filters?: AuditLogsFilters): Promise<AuditLogsResponse> =>
    client.get<AuditLogsResponse>('/audit-logs', { params: filters }),
};
